import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useParams,
  useLocation,
  useNavigate,
} from "react-router-dom";
import MainPage from "./pages/MainPage";
import { useSelector } from "react-redux";
import BreadCrumb from "./Components/BreadCrumb/BreadCrumb";
import Header from "./Components/Navbar/Header";
import BugDashboard from "./pages/BugDashboard/BugDashboard";
import IframePage from "./pages/IframePage/IframePage";
import SubtasksPage from "./pages/SubtasksPage/SubtasksPage";
import { getCookie, isTokenValid } from "./services/utils";
import ProtectedRoute from "./Components/Routes/ProtectedRoute";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";


const BreadcrumbContainer = ({ children }) => {
  const { selectedClient } = useSelector((state) => {
    return state.clientDetails;
  });

  const { selectedProject, isBugDashboard, isBugPage, bugViewMode, isBugSummaryModal } =
    useSelector((state) => {
      return state.bugDetails;
    });
  const {isProjectSetup} = useSelector((state)=>{return state.setupDetails});
  const { clientId, projectId, bugId, subtaskId } = useParams();
  const location = useLocation();
  console.log("bug summary modal:", isBugSummaryModal)
  const breadcrumbItems = [
    { title: "Home", link: "/" },
    clientId && {
      title: location.state?.clientName,
      link: `/client/${clientId}`,
      state: {
        clientName: selectedClient?.label,
      },
    },
    projectId && {
      title: location?.state?.projectName,
      link: `/client/${clientId}/project/${projectId}/subtasks`,
      state: {
        clientName: selectedClient?.label,
        projectName: location?.state?.projectName,
        guid: location?.state?.guid,
      },
    },
    subtaskId && location.state?.subtaskName && { 
      title: location.state.subtaskName, 
      link: `/client/${clientId}/project/${projectId}/subtask/${subtaskId}/bugs` 
    },
    (bugId || isBugSummaryModal) && {
      title: !bugId ? "Add Bug" : "Bug",
      link: `/client/${clientId}/project/${projectId}/bug/${bugId}`,
      state: {
        clientName: selectedClient?.label,
        projectName: location?.state?.projectName,
      },
    },
    isBugDashboard && { title: "Dashboard", link: "" },
    isProjectSetup && { title: "Feature", link: ""},
    location.pathname.includes('/iframe') && { title: "Iframe Page", link: "" },
    // isBugPage && {title: 'Bugs', link : ''},
    // bugViewMode && {title: 'View', link : ''}
  ].filter(Boolean);
  return (
    <>
      {selectedClient?.value ? <BreadCrumb items={breadcrumbItems} /> : null}
      {children}
    </>
  );
};

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isTokenVerified, setIsTokenVerified] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);


  useEffect(() => {
    const handleTokenValidation = async () => {
      const searchParams = new URLSearchParams(location.search);
      const tokenFromUrl = searchParams.get('token') || getCookie("token");
      const tokenValid = await isTokenValid(tokenFromUrl);
      const isReportPage = location.pathname.includes('/report')
      if (tokenValid && !isReportPage) {
        document.cookie = `token=${tokenFromUrl};path=/`;
        setIsTokenVerified(true)
        if (searchParams.has("token")) {
          searchParams.delete("token");
          navigate({ search: '?' + searchParams.toString(), replace: true });
        }
        setIsLoggedIn(true);
      } else {
        if(!isReportPage){
        window.location.href = process.env.REACT_APP_LOGIN_URL
        }
        setIsLoggedIn(false);
      }
    }

    handleTokenValidation();
  }, []);

  useEffect(() => {
    const disableScreenshotShortcuts = (event) => {
      // Prevent common screenshot shortcut combinations
  

      if (
        (event.key === "PrintScreen") || // Print Screen
        (event.ctrlKey && event.key === "PrintScreen") || // Ctrl + Print Screen
        (event.key === "PrintScreen" && event.altKey) || // Alt + Print Screen
        (event.metaKey && event.shiftKey && event.key === "S") || // Windows + Shift + S
        (event.metaKey && event.key === " ") // Windows + Space
      ) {
        // alert("Screenshots are disabled for this content.");
        event.preventDefault();
      }
    };

    document.addEventListener("keydown", disableScreenshotShortcuts);

    // Clean up event listener on unmount
    return () => {
      document.removeEventListener("keydown", disableScreenshotShortcuts);
    };
  }, []);


  
const preventCopy = (event) => {
    event.preventDefault();
  };

const userRole = getCookie('role')

// useEffect(() => {
//     const handleRightClick = (event) => {
//       event.preventDefault();  // Prevent right-click menu
//       console.log("Right click disabled!");
//     };

//     // Add event listener for right-click (context menu)
//     document.addEventListener('contextmenu', handleRightClick);

//     // Cleanup the event listener on component unmount
//     return () => {
//       document.removeEventListener('contextmenu', handleRightClick);
//     };
//   }, []);

// console.log(userRole)

  return (
    <div style={{
        userSelect: userRole === "CONTRACTOR" ? 'none' : 'auto',
        MozUserSelect: userRole === "CONTRACTOR" ? 'none' : 'auto',
        WebkitUserSelect: userRole === "CONTRACTOR" ? 'none' : 'auto',
      }}
      onCopy={userRole === "CONTRACTOR" ? preventCopy : null} 
      onContextMenu={
      userRole === "CONTRACTOR" ? (event) => event.preventDefault() : null
      }
      className="App">
      
        <div className="app-container">
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute isAuthenticated={isLoggedIn} element={<BreadcrumbContainer><MainPage /></BreadcrumbContainer>} />
              }
            >
              <Route path="client/:clientId/" element={<MainPage />} />
              <Route
                exact
                path="client/:clientId/project/:projectId"
                element={<MainPage />}
              />
              <Route
                exact
                path="client/:clientId/project/:projectId/bug/:bugId"
                element={<MainPage />}
              />
              <Route
                exact
                path="client/:clientId/project/:projectId/addBug"
                element={<MainPage />}
              />
              <Route
                exact
                path="client/:clientId/project/:projectId/dashboard"
                element={<MainPage />}
              />
              <Route
                exact
                path="client/:clientId/project/:projectId/feature"
                element={<MainPage />}
              />
            </Route>
            <Route
              exact
              path="client/:clientId/project/:projectId/iframe"
              element={<ProtectedRoute isAuthenticated={isLoggedIn} element={<IframePage />} />}
            />
            <Route
              exact
              path="client/:clientId/project/:projectId/subtasks"
              element={<ProtectedRoute isAuthenticated={isLoggedIn} element={<BreadcrumbContainer><div><Header /><SubtasksPage /></div></BreadcrumbContainer>} />}
            />
            <Route
              exact
              path="client/:clientId/project/:projectId/subtask/:subtaskId/bugs"
              element={<ProtectedRoute isAuthenticated={isLoggedIn} element={<BreadcrumbContainer><MainPage /></BreadcrumbContainer>} />}
            />
            <Route
              exact
              path="client/:clientId/project/:projectId/subtask/:subtaskId/dashboard"
              element={<ProtectedRoute isAuthenticated={isLoggedIn} element={<BreadcrumbContainer><MainPage /></BreadcrumbContainer>} />}
            />
            <Route
              exact
              path="client/:clientId/project/:projectId/subtask/:subtaskId/feature"
              element={<ProtectedRoute isAuthenticated={isLoggedIn} element={<BreadcrumbContainer><MainPage /></BreadcrumbContainer>} />}
            />
            <Route
              exact
              path="client/:clientId/project/:projectId/subtask/:subtaskId/iframe"
              element={<ProtectedRoute isAuthenticated={isLoggedIn} element={<IframePage />} />}
            />
            <Route
                path="/report/:guid"
                element={<BugDashboard />}
              />
            <Route path="*" element={<NotFoundPage   />} />
          </Routes>
        </div>
    </div>
  );
}

export default App;
